<template>
  <div v-if="critereRecherche" class="tableWithPerPageSelection">
    <card-comment-relance class="mgt-20px" v-if="facture"
      :commentaireRelance="facture.commentaireRelance"/>
    <div class="level mgt-20px">
      <div class="level-left">
        <div class="columns">
          <div class="column is-narrow mgl-10px">
            <form @submit.prevent="recherche()">
            <b-input :placeholder="$t('relanceSave.actions.search')" type="search" icon="magnify"
                     v-model="critereRecherche.auto">
            </b-input>
          </form>
          </div>
          <div class='column is-narrow'>
            <button class="button" @click='setShowFiltre'>
              <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
              <span class="is-size-7">{{$t('relanceSave.actions.filtre')}}
                <label class="has-text-weight-bold"
                       :class="nombreCritere > 0 ? '' : 'is-invisible'">
                  ({{ nombreCritere }})
                </label>
              </span>
            </button>
            <span @click="reinitialiser()"
              class="info-circle-right is-pulled-right is-cursor-pointer">
              <b-icon icon="close-circle" type="is-danger"></b-icon>
            </span>
          </div>
        </div>
      </div>
      <div class="level-right columns">
        <div class="column is-narrow">
          <exportExcelButton
            :perm="permissionsRelances.exporter"
            in-progress/>
        </div>
        <parametrage-table
          :reference-table="referenceTable"
          @endLoadParamtre="startArrayRendering = true">
        </parametrage-table>
      </div>
    </div>
    <v-server-table
      v-if="startArrayRendering && mountedLoadingEnd"
      url=""
      :columns="columns"
      :options="options"
      :ref="referenceTable"
      @loaded="finLoading"
      @loading="debutLoading">
      <template slot='afterTable'>
        <table-items-in-view
          :perPage="resultPerPage"
          @input="$refs[referenceTable].setLimit($event)" />
      </template>
      <div slot="relanceLibelle" slot-scope="props">
        <router-link-blank
          :to="{ name: 'c.bodac.relance', params: { relanceId: props.row.id }}"
          :message="props.row.relanceLibelle"/>
      </div>
      <div slot="dateRelance" slot-scope="props">
        {{ props.row.dateRelance | formatDate }}
      </div>
      <div slot="dateFacture" slot-scope="props">
        <p v-if="getFactures(props.row.mouvementsClients).ids.length === 1">
          {{ props.row.mouvementsClients[0].facture.date | formatDate }}
        </p>
        <div v-else  class="lien is-cursor-pointer"
          @click="actionOnClick(props.row.mouvementsClients)">
          {{ $t('listeRelanceForClient.multiFacture') }}</div>
      </div>
      <div slot="etat" slot-scope="props">
        {{ $t(getEtat(props.row.etat)) }}
      </div>
      <div slot="facture" slot-scope="props">
        <router-link-blank
          v-if="getFactures(props.row.mouvementsClients).ids.length === 1"
          :to="{
            name: 'c.bodac.factures',
            params: { id: getFactures(props.row.mouvementsClients).ids[0] }
          }"
          :message="getFactures(props.row.mouvementsClients).codes"/>
        <div
          v-else
          @click="actionOnClick(props.row.mouvementsClients)"
          class="lien is-cursor-pointer">
          {{ $t('listeRelanceForClient.multiFacture') }}</div>
      </div>
      <div slot="niveauRelance" slot-scope="props">
        {{ props.row.numRelance }}
      </div>
      <div slot="montant" slot-scope="props" class="is-pulled-right">
        {{ getMontantRelance(props.row.mouvementsClients) | formatDevise }}
      </div>
      <div slot="commentaire" slot-scope="props">
        <commentaireListInput
          :id="props.row.id"
          v-model="props.row.commentaire"
          :maj="majCom">
        </commentaireListInput>
      </div>
    </v-server-table>
    <div class="componentBrief" v-show="showFiltre === true">
      <filtre-relance
        ref="filtreRelance"
        :is-from-relance-save="false"
        :tiers="tiersInformation"
        @toggleFiltre="setShowFiltre"
        @recherche="makeRechercheFilter()"/>
    </div>
    <b-modal
      v-model="afficherListeFactures"
      has-modal-card
      class="modal">
      <pop-up-mouvement-clients-facture
        :mouvementsClients="mouvementsClientsDeLaRelance"
        @close="afficherListeFactures = false">
      </pop-up-mouvement-clients-facture>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import {
  TEXTS, RESULTS_PER_PAGE, SORT_ICON, NO_PER_PAGE_VALUE,
} from '@/configuration/clientTableConf';
import { RELANCE } from '@/configuration/permissionsBodacConf';
import formatIsoDate from '@/services/general/formatIsoDate';
import * as relanceConf from '@/configuration/relances/relancesConf';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import { SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import filtreRelance from '@/components/relances/filtreRelance';
import * as types from '@/store/modules/relance-mutation-type';
import TableItemsInView from '@/components/general/TableItemsInView';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import messageErreur from '@/services/general/messageErreur';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import parametrageTable from '@/components/general/parametrageTable';
import { REFERENCE_TABLE_RELANCE_CLIENT } from '@/configuration/general/referenceTableConf';
import popUpMouvementClientsFacture from '@/components/relances/p_mouvementClientsFacture';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { columnsSplice } from '@/services/general/columns';
import cardCommentRelance from '@/components/factures/detail/cardCommentRelance';
import commentaireListInput from '@/components/general/input/commentaireListInput/commentaireListInput';
import { commenter } from '@/api/relances/index';

const relance = createNamespacedHelpers('relance');
const societe = createNamespacedHelpers('societe');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');
const permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    tiersInformation: {
      type: Object,
      required: false,
    },
    facture: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      permissionsRelances: RELANCE,
      showFiltre: false,
      referenceTable: REFERENCE_TABLE_RELANCE_CLIENT,
      afficherListeFactures: false,
      mouvementsClientsDeLaRelance: null,
      startArrayRendering: false,
      mountedLoadingEnd: false,
      resultPerPage: RESULTS_PER_PAGE,
    };
  },
  beforeDestroy() {
    if (this.lockMenu) this.setLockMenu(false);
  },
  components: {
    routerLinkBlank,
    filtreRelance,
    TableItemsInView,
    parametrageTable,
    popUpMouvementClientsFacture,
    exportExcelButton,
    cardCommentRelance,
    commentaireListInput,
  },
  computed: {
    ...relance.mapGetters({
      items: 'items',
      totalCount: 'totalCount',
      critereRecherche: 'critereRechercheFactureTiers',
    }),
    ...societe.mapGetters({
      societeActiveId: 'societeActiveId',
      societeActive: 'societeActive',
      agencesSelectionnees: 'agenceActive',
      lockMenu: 'lockMenu',
    }),
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
      parametresInterne: 'parametresInterne',
    }),
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    columns() {
      const columns = ['relanceLibelle', 'dateRelance', 'etat', 'facture', 'dateFacture', 'niveauRelance', 'montant', 'commentaire'];
      if (this.$route.name === 'c.bodac.factures') {
        columnsSplice(columns, 'facture');
        columnsSplice(columns, 'dateFacture');
      }
      return columns;
    },
    nombreCritere() {
      const banCritere = ['date', 'societeId', 'datesFacture', 'actif', 'datesRelance', 'payeurs'];
      if (this.societeActive.agences.length === 1) banCritere.push('agenceIdFacture');
      let nbFiltre = calculNombreCritere(this.critereRecherche, banCritere);

      if (this.critereRecherche.datesFacture.dateDebut
        || this.critereRecherche.datesFacture.dateFin) nbFiltre += 1;
      if (this.critereRecherche.datesRelance.dateDebut
        || this.critereRecherche.datesRelance.dateFin) nbFiltre += 1;
      nbFiltre += this.critereRecherche.actif !== null ? 1 : 0;
      if (nbFiltre > 9) return '9+';
      return nbFiltre;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          relanceLibelle: this.$i18n.t('listeRelanceForClient.tabs.libelle'),
          dateRelance: this.$i18n.t('listeRelanceForClient.tabs.dateRelance'),
          etat: this.$i18n.t('listeRelanceForClient.tabs.etat'),
          facture: this.$i18n.t('listeRelanceForClient.tabs.numFacture'),
          dateFacture: this.$i18n.t('listeRelanceForClient.tabs.dateFacture'),
          niveauRelance: this.$i18n.t('listeRelanceForClient.tabs.niveauRelance'),
          montant: this.$i18n.t('listeRelanceForClient.tabs.montant'),
          commentaire: this.$i18n.t('listeRelanceForClient.tabs.commentaire'),
        },
        sortable: ['dateRelance', 'etat'],
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        requestFunction: ((data) => {
          if (data.orderBy === undefined) {
            data.orderBy = 'creationTime';
            data.ascending = 0;
          }
          data.query = cloneDeep(this.critereRecherche);
          data.query.date = formatIsoDate(new Date());
          data.query.societeId = this.societeActiveId;
          if (this.critereRecherche.agenceIdFacture.length === 0) {
            data.query.agenceIdFacture = this.agencesSelectionnees.map(agence => agence.agenceId);
          }
          if (data.query.payeurs.length > 0) {
            data.query.tiersId = data.query.payeurs.map((payeur) => {
              return payeur.id;
            });
          }
          delete data.query.payeurs;
          return this.actionsLoadRelances(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.items,
            count: this.totalCount,
          };
        }),
      };
    },
    filtrerParUtilisateur() {
      return this.parametresInterne(
        PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key,
      );
    },
  },
  methods: {
    ...relance.mapMutations({
      setCritereRecherche: types.SET_CRITERE_RECHERCHE_COMMUN,
    }),
    ...relance.mapActions({
      actionsLoadRelances: 'loadRelances',
    }),
    ...societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    async setShowFiltre() {
      this.showFiltre = !this.showFiltre;
      if (this.showFiltre) await this.$refs.filtreRelance.initializeFiltre();
      this.setLockMenu(!this.lockMenu);
    },
    makeRechercheFilter() {
      if (this.showFiltre) this.showFiltre = !this.showFiltre;
      this.recherche();
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    debutLoading() {
      if (this.loadingComponent) {
        this.loadingComponent.close();
      }
      this.loadingComponent = this.$buefy.loading.open();
    },
    getEtat(etatRelance) {
      const etat = relanceConf.ETAT_RELANCES.find((el) => {
        return etatRelance === el.etat;
      });
      return etat.libelle;
    },
    async reinitialiser() {
      await this.$refs.filtreRelance.initializeFiltre();
      await this.$refs.filtreRelance.viderCritere();
      this.$refs.filtreRelance.appliquerCritere();
      this.showFiltre = false;
    },
    getMontantRelance(mouvementClients) {
      return mouvementClients.map(mvt => mvt.montantEcheance)
        .reduce((a, b) => a + b, 0);
    },
    getFactures(mouvementClients) {
      const codes = [...new Set(mouvementClients.map(mvt => {
        return mvt.facture.code;
      }))].join(',');
      const ids = [...new Set(mouvementClients.map(mvt => {
        return mvt.facture.id;
      }))];
      return { codes, ids };
    },
    actionOnClick(mouvementsClients) {
      this.mouvementsClientsDeLaRelance = mouvementsClients;
      this.afficherListeFactures = true;
    },
    majCom(id, commentaire) {
      return commenter({
        id: id,
        commentaire: commentaire,
      });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([PARAMETRES_INTERNE_KEYS.filtrerAutoParUtilisateur.key]);
      const critere = cloneDeep(this.critereRecherche);
      if (this.filtrerParUtilisateur
        && (this.user.profil === COMMERCIAL || this.user.profil === DIRECTEUR_COMMERCIAL)) {
        critere.commercialId = [this.user.id];
      }
      if (this.$route.name === 'c.bodac.clients/contacts-relances') {
        critere.tiersId = [this.$route.params.id];
      }
      if (this.$route.name === 'c.bodac.factures') {
        critere.codeFacture = this.facture.code;
      }
      this.setCritereRecherche(critere);
      this.mountedLoadingEnd = true;
      this.setInformationPage(this.$t('pageGeneral.detail', { item: this.tiersInformation?.nomCommercial || this.facture?.code }));
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw (e);
    }
  },
};
</script>

<style scoped>

</style>
